export default {
  data() {
    return {
      isFavorite: false,
      isDisabled: false,
    };
  },
  watch: {
    photo(photo) {
      if (photo) {
        this.markFavorite(photo.id);
      }
    },
    favorites(favorites) {
      if (favorites) {
        this.markFavorite(this.photo.id);
      }
    },
  },
  methods: {
    markFavorite(id) {
      if (this.album && this.album.id) {
        const album = this._.find(this.favorites, {albumId: this.album.id});

        if (album) {
          this.isFavorite = !!this._.find(album.items, {photoId: id});
        }
      }
    },
    async handleFavorite() {
      this.isFavorite = !this.isFavorite;

      this.isDisabled = true;
      if (this.isFavorite) {
        await this.$store.dispatch('ADD_FAVORITE', {
          albumId: this.album.id,
          albumTitle: this.album.title !== null ? this.album.title : this.$t(
              'no_name'),
          albumStatus: this.album.status,
          albumHash: this.album.hash,
          albumHashPassword: this.album.hash_password,
          tag: this.$store.getters.ALBUM_TAG,
          photoId: this.photo.id,
          photoPath: this.photo.medium_photo,
          freeDownload: this.photo.free_download ? +this.photo.free_download : 0,
        });
      } else {
        await this.$store.dispatch('DELETE_FAVORITE',
            {albumId: this.album.id, photoId: this.photo.id});
      }
      this.isDisabled = false;
    },
    back() {
      this.$emit('handle-fullscreen', false);
      this.closeOrder();
    },
    next() {
      this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);
      this.$emit('handle-fullscreen', false);

      this.$store.dispatch('INIT_ORDER');
      this.$store.dispatch('ADD_PHOTO', this.photo);
      this.$router.push(
          this.i18nLink(`album/gallery/${this.getAlbumId()}/order`));
    },
  },
  created() {
    if (this.album && this.photo) {
      this.markFavorite(this.photo.id);
    }
  },
};
